import React from "react";
import { ArrowRight, ArrowDown } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
export default function TaxiBookingSteps() {
  const steps = [{
    number: "1",
    stepLabel: "Schritt 1",
    title: "Abhol- und Zieldetails eingeben"
  }, {
    number: "2",
    stepLabel: "Schritt 2",
    title: "Bestätigung und vereinbarten Preis erhalten"
  }, {
    number: "3",
    stepLabel: "Schritt 3",
    title: "Fahrer treffen und private Fahrt abschließen"
  }];
  return <section id="howlocaltaxibookingworks" data-nav="light" className="bg-background text-foreground py-16 md:py-20">
      <div className="max-w-[1136px] mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
            So funktioniert die lokale Taxibuchung
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-4 relative items-stretch">
          {steps.map((step, i) => <React.Fragment key={step.number}>
              <div data-index={i} className="relative flex flex-col items-center text-center flex-1">
                <Card className="w-full h-full bg-card border-border/70 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
                  <CardContent className="pt-8 pb-8 px-6 flex flex-col items-center text-center h-full">
                    {/* Numbered Circular Badge */}
                    <div className="size-14 rounded-full bg-primary text-primary-foreground font-bold text-xl flex items-center justify-center shadow-xs mb-6 shrink-0">
                      {step.number}
                    </div>

                    <span className="text-xs font-semibold uppercase tracking-wider text-accent-foreground mb-2">
                      {step.stepLabel}
                    </span>

                    <h3 className="text-lg md:text-xl font-medium text-foreground leading-snug">
                      {step.title}
                    </h3>
                  </CardContent>
                </Card>

                {/* Connecting Arrow for Desktop */}
                {i < steps.length - 1 && <div aria-hidden="true" className="hidden md:flex absolute -right-3 lg:-right-4 top-1/2 -translate-y-1/2 z-10 text-accent-foreground">
                    <ArrowRight className="size-6 stroke-[2.5]" />
                  </div>}

                {/* Connecting Arrow for Mobile */}
                {i < steps.length - 1 && <div aria-hidden="true" className="flex md:hidden text-accent-foreground my-2 justify-center">
                    <ArrowDown className="size-5 stroke-[2.5]" />
                  </div>}
              </div>
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}